import { InfoCircleOutlined } from '@ant-design/icons';
import { Badge, Tooltip } from 'antd';
import { useCustomerNameWithLabels } from 'helpers/hooks/useCustomerNameWithLabels';
import React, { ReactNode } from 'react';
import { Condition, JsonDataItem } from 'types';

type CustomerHeadingRibbonProps = {
  customer: JsonDataItem | null;
  children?: ReactNode;
};

export const CustomerHeadingRibbon: React.FC<CustomerHeadingRibbonProps> = ({ customer, children }) => {
  const ribbonText = useCustomerNameWithLabels(customer);
  const isDanger = customer?.blacklist === Condition.Yes;
  const info = customer?.blacklist_reason; // TODO: adjust the key when it's provided
  return (
    <Badge.Ribbon
      text={
        <>
          {ribbonText}
          {info ? (
            <>
              {' '}
              <Tooltip title={info}>
                <InfoCircleOutlined />
              </Tooltip>
            </>
          ) : null}
        </>
      }
      color={isDanger ? 'red' : 'blue'}
      placement="start"
      style={{ top: 12, opacity: Number(!!ribbonText) }}
    >
      {children}
    </Badge.Ribbon>
  );
};
